import React, { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import BackToTop from "@/components/common/BackToTop";
import ChatWidget from "@/components/common/ChatWidget";
import CookieConsent from "@/components/common/CookieConsent";
import { HeaderThemeProvider, useHeaderTheme } from "@/context/HeaderThemeContext";

function ScrollAndThemeReset() {
  const { pathname } = useLocation();
  const { setTheme } = useHeaderTheme();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    // Interior pages default to a dark (over-light) header; Hero re-detects on home.
    setTheme("dark");
  }, [pathname, setTheme]);
  return null;
}

export default function PublicLayout({ children }) {
  return (
    <HeaderThemeProvider>
      <div className="flex min-h-screen flex-col bg-white">
        <ScrollAndThemeReset />
        <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-primary focus:px-4 focus:py-2 focus:text-white">
          Skip to content
        </a>
        <Navbar />
        <main id="main" className="flex-1">{children || <Outlet />}</main>
        <Footer />
        <BackToTop />
        <ChatWidget />
        <CookieConsent />
      </div>
    </HeaderThemeProvider>
  );
}
